var ConditionalWrapper = function(param) {
    var condition = param.condition, thenWrapper = param.thenWrapper, elseWrapper = param.elseWrapper, children = param.children;
    return condition ? thenWrapper(children) : elseWrapper ? elseWrapper(children) : children;
};
export default ConditionalWrapper;
